import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAllRegionGroups() {
  const response = await $.soap({
    body: {
      GetAllRegionGroups: {
        $xmlns: 'http://dla.mil/ems/db/lookup/lu_region_group'
      }
    },
    blueprintArrays: ['GetAllRegionGroupsResponse.tuple'],
    blueprint: {
      regionGroups: [
        '$..GetAllRegionGroupsResponse.tuple',
        {
          id: '$..ID',
          regionGroup: '$..RegionGroup',
          name: '$..RegionGroup'
        }
      ]
    }
  });
  cleanUpResponse(response);
  return response.regionGroups;
}
